import {
    createLoadingSpinner,
    LoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
} from '@vfde-brix/ws10/loading-spinner';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';

/**
 * Create Brix LoadingSpinner component.
 * @param {HtmlId} id - Wrapper ID of the element.
 * @param {boolean} [isNested=false] - Place the loading spinner as a nested child
 * element inside a block/parent container.
 * @returns {LoadingSpinner|null} Loading Spinner component or undefined
 * if element with given id is not found.
 */
export const mountLoadingSpinner = (id: HtmlId, isNested: boolean = false): LoadingSpinner | null =>
    createComponentById(createLoadingSpinner, id, {
        optNested: isNested,
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

/**
 * Set the visibility of the Loading Spinner component.
 * @param {LoadingSpinner|null} spinner - Component to show or hide.
 * @param {boolean} isVisible - Should the component be visible?
 */
export const setLoadingSpinnerVisibility = (spinner: LoadingSpinner | null, isVisible: boolean) => {
    if (!spinner) {
        return;
    }

    spinner.toggle(isVisible);
};
